@if (selectedTool$ | async; as selectedTool) {
  @if (selectedTool.customizations) {
    <div
      class="pdf-editor-tool-customization"
      >
      @if (selectedTool.type === pdfEditorToolType.Pen) {
        <div
          class="pdf-editor-tool-customization-items"
          >
          @if ($any(selectedTool.customizations)?.width) {
            <div
              class="pdf-editor-tool-customization-item"
              >
              <label class="font-medium text-xs">Stärke</label>
              <input
                type="range"
                class="h-6"
                [value]="selectedTool.options.width ?? 1"
                [min]="$any(selectedTool.customizations)?.width?.min ?? 1"
                [max]="$any(selectedTool.customizations)?.width?.max ?? 16"
                (input)="onOptionChange(selectedTool, 'width', +$any($event.target).value)"
                />
            </div>
          }
          @if ($any(selectedTool.customizations)?.color) {
            <div
              class="pdf-editor-tool-customization-item"
              >
              <label class="font-medium text-xs">Farbe</label>
              <input
                type="color"
                class="h-6"
                [value]="selectedTool.options.color"
                (input)="onOptionChange(selectedTool, 'color', $any($event.target).value)"
                />
            </div>
          }
        </div>
      }
      @if (selectedTool.type === pdfEditorToolType.Marker) {
        <div
          class="pdf-editor-tool-customization-items"
          >
          @if ($any(selectedTool.customizations)?.color) {
            <div
              class="pdf-editor-tool-customization-item"
              >
              <label class="font-medium text-xs">Farbe</label>
              <div class="flex flex-row w-full place-content-evenly">
                <div
                  class="circle pointer"
                  [style]="{ background: 'rgba(255, 0, 0, 0.3)' }"
            [class.selected]="
              selectedTool.options.color === 'rgba(255, 0, 0, 0.3)'
            "
            (click)="
              onOptionChange(selectedTool, 'color', 'rgba(255, 0, 0, 0.3)')
            "
                ></div>
                <div
                  class="circle pointer"
                  [style]="{ background: 'rgba(255, 255, 0, 0.5)' }"
            [class.selected]="
              selectedTool.options.color === 'rgba(255, 255, 0, 0.5)'
            "
            (click)="
              onOptionChange(selectedTool, 'color', 'rgba(255, 255, 0, 0.5)')
            "
                ></div>
                <div
                  class="circle pointer"
                  [style]="{ background: 'rgba(0, 0, 255, 0.3)' }"
            [class.selected]="
              selectedTool.options.color === 'rgba(0, 0, 255, 0.3)'
            "
            (click)="
              onOptionChange(selectedTool, 'color', 'rgba(0, 0, 255, 0.3)')
            "
                ></div>
                <div
                  class="circle pointer"
                  [style]="{ background: 'rgba(0, 255, 0, 0.3)' }"
            [class.selected]="
              selectedTool.options.color === 'rgba(0, 255, 0, 0.3)'
            "
            (click)="
              onOptionChange(selectedTool, 'color', 'rgba(0, 255, 0, 0.3)')
            "
                ></div>
              </div>
            </div>
          }
        </div>
      }
      @if (selectedTool.type === pdfEditorToolType.TextBox) {
        <div
          class="pdf-editor-tool-customization-items"
          >
          @if ($any(selectedTool.customizations)?.fontSize) {
            <div
              class="pdf-editor-tool-customization-item"
              >
              <label class="font-medium text-xs">Schriftgröße</label>
              <input
                type="range"
                class="h-6"
                [value]="selectedTool.options.fontSize ?? 1"
                [min]="$any(selectedTool.customizations)?.fontSize?.min ?? 1"
                [max]="$any(selectedTool.customizations)?.fontSize?.max ?? 16"
          (input)="
            onOptionChange(selectedTool, 'fontSize', +$any($event.target).value)
          "
                />
            </div>
          }
          @if ($any(selectedTool.customizations).backgroundColor) {
            <div
              class="pdf-editor-tool-customization-item"
              >
              <label class="font-medium text-xs">Hintergrundfarbe</label>
              <input
                type="color"
                class="h-6"
                [value]="selectedTool.options.backgroundColor"
          (input)="
            onOptionChange(selectedTool, 'backgroundColor', $any($event.target).value)
          "
                />
            </div>
          }
          @if ($any(selectedTool.customizations)?.fill) {
            <div
              class="pdf-editor-tool-customization-item"
              >
              <label class="font-medium text-xs">Textfarbe</label>
              <input
                type="color"
                class="h-6"
                [value]="selectedTool.options.fill"
                (input)="onOptionChange(selectedTool, 'fill', $any($event.target).value)"
                />
            </div>
          }
        </div>
      }
    </div>
  }
}
